import { useId } from 'react';
import type { ReactNode } from 'react';
import { PALETTE } from '../../lib/labels';

interface FieldProps {
  label: string;
  error?: string | undefined;
  hint?: string;
  className?: string;
  children: (props: { id: string; 'aria-invalid': boolean }) => ReactNode;
}

/** Beschriftung, Fehlermeldung und Hilfetext — einheitlich verdrahtet. */
export function Field({ label, error, hint, className, children }: FieldProps) {
  const id = useId();
  return (
    <div className={`field ${className ?? ''}`}>
      <label className="label" htmlFor={id}>
        {label}
      </label>
      {children({ id, 'aria-invalid': Boolean(error) })}
      {error ? <span className="field-error">{error}</span> : null}
      {!error && hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
}

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label: string;
}

export function ColorPicker({ value, onChange, label }: ColorPickerProps) {
  return (
    <div className="field">
      <span className="label">{label}</span>
      <div className="color-grid" role="group" aria-label={label}>
        {PALETTE.map((color) => (
          <button
            key={color}
            type="button"
            className="color-chip"
            style={{ background: color }}
            aria-pressed={value.toLowerCase() === color.toLowerCase()}
            aria-label={`Farbe ${color}`}
            onClick={() => onChange(color)}
          />
        ))}
      </div>
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <h3>{title}</h3>
      <p>{description}</p>
      {action ? <div style={{ marginTop: 'var(--space-4)' }}>{action}</div> : null}
    </div>
  );
}
